import { WizardApiService } from './api/WizardApiService';
import { fetchUserAttributes } from 'aws-amplify/auth';

// Export all modules for individual use
export { HttpClient, HttpError } from './http';
export { CacheManager } from './cache';
export { WizardApiService } from './api/WizardApiService';

// Create and export default wizard API instance

export const wizardApi = new WizardApiService();
wizardApi.setUserAttributesGetter(fetchUserAttributes);

// For backward compatibility
export default wizardApi;